
import { server } from "../utils/server";

const registerLeads = (data) =>{
    return server.post("interest/register",data)
    .then(res=>{
        console.log(res.data);
        return res.data;
    })
    .catch(err=>{
        console.log(err);
        return null;
    })
}



const leadService = {
    registerLeads
}

export default leadService;